export default __webpack_public_path__ + "static/media/top-left-svg.8f7c8d24.svg";